import { Link } from '@tanstack/react-router';
import { useAuthStore } from '../store/auth.ts';
import { ThemeToggle } from './ThemeToggle.tsx';
import { Icon } from './Icon.tsx';

// Material 3 top app bar (desktop) — menu + logo on the left, theme / sign-out /
// avatar on the right. (Search lives above the document list, not here.)
export function TopBar(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  if (!user) return null;
  const initials = (user.name ?? user.email).slice(0, 2).toUpperCase();

  return (
    <header
      className="hidden md:flex fixed top-0 inset-x-0 z-40 h-16 items-center gap-2 pl-3 pr-8 bg-[hsl(var(--chrome))]"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <Link to="/" className="flex items-center gap-3 ml-2 min-w-0">
        <img src="/icons/wapsign-mark.svg" alt="" className="size-10 shrink-0 rounded-[25%] object-contain" />
        <span className="flex min-w-0 flex-col">
          <span className="text-xl font-medium text-ink leading-tight whitespace-nowrap">WapSign</span>
          {user.orgName && (
            <span className="text-xs text-muted-foreground truncate leading-tight">{user.orgName}</span>
          )}
        </span>
      </Link>

      <div className="flex-1" />

      <div className="flex items-center gap-1 shrink-0">
        <ThemeToggle />
        <button
          onClick={logout}
          aria-label="Sign out"
          className="grid size-11 place-items-center rounded-full text-muted-foreground hover:bg-muted/70 transition-colors"
        >
          <Icon name="logout" size={22} />
        </button>
        <Link
          to="/profile"
          aria-label="Profile"
          title={user.name ?? undefined}
          className="grid size-9 ml-1 place-items-center rounded-full bg-[hsl(var(--tertiary-container))] text-[hsl(var(--on-tertiary-container))] text-sm font-medium"
        >
          {initials}
        </Link>
      </div>
    </header>
  );
}
